let language = {
    500002: "当前优惠券代码无效，请输入其他代码并重试。",
    500001: "当前优惠码已使用过一次，现已无效。请输入其他优惠码并重试。",
    500003: "当前优惠券代码已过期，请输入其他代码并重试",
    500005: "当前优惠券代码已过期，请输入其他代码并重试"
};

export { language }
